import { format, parse, parseISO } from 'date-fns';

export function getDateTimeStringForDisplay({ dateISO, timeISO }: { dateISO: string; timeISO: string | null }) {
    const dateString = format(parseISO(dateISO), 'PPP');

    if (timeISO) {
        return `${dateString} at ${format(parse(timeISO, 'HH:mm:ss', new Date()), 'p')}`;
    }

    return dateString;
}
